import type { StockStatus } from 'types/capi/shared';

type Props = {
  isSizeSelected: boolean;
  stockStatus: StockStatus;
};

export default function Title({ stockStatus, isSizeSelected }: Props) {
  return (
    <div
      data-cy="wtb-title"
      className="flex items-center justify-between text-lg font-bold tracking-wide text-black"
    >
      {getNotificationText(stockStatus, isSizeSelected)}
    </div>
  );
}

function getNotificationText(
  stockStatus: StockStatus,
  isSizeSelected: boolean
) {
  if (stockStatus === 'SOLD_OUT') return 'Get notified of restocks';

  if (stockStatus === 'IN_STOCK' && isSizeSelected)
    return 'Available in your size at';

  if (stockStatus === 'IN_STOCK') return 'Our recommended retailer';

  return 'Get notified when they release';
}
